export enum UserRole {
  TECH = 'tech',
  HR = 'hr',
}
